var _path, _circle, _circle2, _path2, _circle3, _path3, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecursosLogoNeg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 22,
    viewBox: "0 0 34 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.521 9.14583C30.3002 7.01491 28.1116 3.85524 26.7752 2.16923C25.0752 0.0246265 19.1252 0.882454 19.1252 4.31377C19.1252 6.02943 19.1252 9.88968 19.1252 13.75",
    stroke: "#4AB3E5",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.2082,
    cy: 13.75,
    r: 6.79167,
    stroke: "#4AB3E5",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.2083,
    cy: 13.75,
    r: 3.95833,
    stroke: "#4AB3E5",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8335 8.79167C4.12207 6.66074 5.38943 3.85524 6.80016 2.16923C8.59461 0.0246265 14.8752 0.882454 14.8752 4.31377C14.8752 6.02943 14.8752 9.88968 14.8752 13.75",
    stroke: "#4AB3E5",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.79167,
    cy: 13.75,
    r: 6.79167,
    stroke: "#4AB3E5",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.875 4.54166H19.125M14.875 8.79166H19.125",
    stroke: "#4AB3E5",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.79183,
    cy: 13.75,
    r: 3.95833,
    stroke: "#4AB3E5",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecursosLogoNeg);
export default __webpack_public_path__ + "static/media/recursos-logo-neg.606c0ebe9385f6dce2429f12ef41327b.svg";
export { ForwardRef as ReactComponent };